import { tryAutoLogin, exchangeAuthCode, processGoogleTokens } from '@/core/services/auth';
import Cookies from 'js-cookie';
import axios from 'axios';

const state = {
  userId: null,
  user: null,
  token: null,
  isAuthenticated: false
};

const mutations = {
  setUser(state, user) {
    state.userId = user?.id || null;
    state.user = user;
  },
  setToken(state, token) {
    state.token = token;
    state.isAuthenticated = !!token;
  }
};

const actions = {
  async tryAutoLogin({ commit, dispatch }) {
    try {
      const jwt = Cookies.get('jwt');
      if (!jwt) return null;

      axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
      const userData = await tryAutoLogin();
      
      if (userData) {
        commit('setUser', userData);
        commit('setToken', jwt);
        
        // Load player data after successful login
        await dispatch('player/loadPlayerData', null, { root: true });
        
        return userData;
      }
      
      return null;
    } catch (error) {
      console.error('Auto login failed:', error);
      commit('setUser', null);
      commit('setToken', null);
      Cookies.remove('jwt');
      return null;
    }
  },
  
  // Exchange auth code for token
  async exchangeCodeForToken({ commit, dispatch }, { code, provider = 'google' }) {
    try {
      const response = await exchangeAuthCode(code, provider);
      
      if (response && response.jwt) {
        const { jwt, user } = response;
        
        Cookies.set('jwt', jwt);
        axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
        
        commit('setUser', user);
        commit('setToken', jwt);
        
        // Load player data after successful token exchange
        await dispatch('player/loadPlayerData', null, { root: true });
        
        return user;
      }
      
      return null;
    } catch (error) {
      console.error('Code exchange failed:', error);
      return null;
    }
  },
  
  // Process Google tokens directly
  async processGoogleTokens({ commit, dispatch }, { idToken, accessToken }) {
    try {
      const response = await processGoogleTokens(idToken, accessToken);
      
      if (response && response.jwt) {
        const { jwt, user } = response;
        
        commit('setUser', user);
        commit('setToken', jwt);
        
        // Load player data after successful Google login
        await dispatch('player/loadPlayerData', null, { root: true });
        
        return user;
      }
      
      return null;
    } catch (error) {
      console.error('Google token processing failed:', error);
      return null;
    }
  },
  
  // Logout
  logout({ commit }) {
    commit('setUser', null);
    commit('setToken', null);
    Cookies.remove('jwt');
    delete axios.defaults.headers.common['Authorization'];
  }
};

const getters = {
  currentUser: (state) => state.user,
  currentUserId: (state) => state.userId,
  currentPlayerId: (state) => state.userId, // Alias for compatibility
  isAuthenticated: (state) => state.isAuthenticated,
  token: (state) => state.token,
  isAdmin: (state) => state.user?.authPanelAdmin || false
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
